import React from 'react';
import moment from 'moment';

import SelectField from './SelectField';
import { remCss } from 'src/helpers';

export const TimePickerField = React.memo(
  ({ label, width, name, onSelect, invalid = {}, template = 1, disabled, value, duration = 5 }) => {
    const times = [];
    for (let i = 0; i < 24 * 60; i += duration) {
      const hours = Math.floor(i / 60);
      const minutes = i % 60;
      const time = String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0');
      times.push({
        value: time,
        label: time
      });
    }

    return (
      <SelectField
        width={width || remCss(130)}
        options={times}
        template={template}
        label={label}
        isClearable={false}
        name={name}
        disabled={disabled}
        value={value && value.format('HH:mm')}
        onChange={(n, v) => {
          const date = value ? moment(value) : moment();
          onSelect(moment(date.format('DDMMYYYY ') + v, 'DDMMYYYY HH:mm'));
        }}
        invalid={invalid}
      />
    );
  }
);
TimePickerField.displayName = 'TimePickerField';
